import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../../contexts/PopupContext';
import { getEventApplicationHostDisplayName } from '../../../utils/profileDisplayName';
import './PendingApplicationsList.css';

/**
 * Komponent listy osób oczekujących w kolejce na zatwierdzenie
 */
function PendingApplicationsList({ applications, onAccept, onReject }) {
  const { t } = useTranslation('events');
  const { openPopup } = usePopup();

  const handleUserClick = (userId) => {
    openPopup('profile', { userId }, 0);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pl-PL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (!applications || applications.length === 0) {
    return null;
  }

  return (
    <div className="pending-applications-list">
      <div className="pending-applications-list-header">
        <h3 className="pending-applications-list-title">
          {t('events.applications.title')}
        </h3>
        <span className="pending-applications-list-count">
          {applications.length} {t('events.applications.count', { count: applications.length })}
        </span>
      </div>

      <div className="pending-applications-list-items">
        {applications.map((application) => {
          const user = application.user;
          const userName = getEventApplicationHostDisplayName(user, {
            unknownLabel: t('events.applications.unknownUser'),
          });

          return (
            <div key={application.id} className="pending-applications-list-item">
              <div className="pending-applications-list-item-content">
                <div className="pending-applications-list-item-user">
                  <button
                    className="pending-applications-list-item-avatar"
                    onClick={() => handleUserClick(application.user_id)}
                    type="button"
                  >
                    {userName.charAt(0).toUpperCase()}
                  </button>
                  <div className="pending-applications-list-item-info">
                    <button
                      className="pending-applications-list-item-name"
                      onClick={() => handleUserClick(application.user_id)}
                      type="button"
                    >
                      {userName}
                    </button>
                    <div className="pending-applications-list-item-meta">
                      <span className="pending-applications-list-item-date">
                        {formatDate(application.created_at)}
                      </span>
                    </div>
                    {application.message && (
                      <div className="pending-applications-list-item-message">
                        "{application.message}"
                      </div>
                    )}
                  </div>
                </div>
                <div className="pending-applications-list-item-actions">
                  <button
                    className="pending-applications-list-item-button accept-button"
                    onClick={() => onAccept(application)}
                    title={t('events.applications.accept')}
                  >
                    ✓ {t('events.applications.accept')}
                  </button>
                  <button
                    className="pending-applications-list-item-button reject-button"
                    onClick={() => onReject(application)}
                    title={t('events.applications.reject')}
                  >
                    ✗ {t('events.applications.reject')}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PendingApplicationsList;
